import React, { useEffect, useState } from 'react'
import { View, Text, Image, StyleSheet, Platform, Animated, Easing } from 'react-native';
import { useSelector } from 'react-redux'
import styles from '../styles';
import * as Component from '../components';
import { global, colors } from '../const';
import SubtitleCapBold from './labels/SubtitleCapBold';
import BodyTitle from './labels/BodyTitle';
import Button from './form/Button';

import { calendar_ic, riddle_ic } from "../assets";
import { PrimaryCaption, PrimaryTitle } from './labels';
import localize from '../localize';

export function WCTaskPaper({ handleClick }) {
    let { daily_task } = useSelector(({ main }) => main)
    daily_task = daily_task || []

    // const [fadeAnim] = useState(new Animated.Value(0))
    // useEffect(() => {
    //     Animated.timing(
    //         fadeAnim,
    //         {
    //             toValue: 1,
    //             easing: Easing.bounce,
    //             duration: 2000,
    //         }
    //     ).start();
    // }, [])

    if (daily_task.status === 201) return null;
    return (
        <View style={pageStyles.paper}>
            <View style={pageStyles.header}>
                <PrimaryCaption weight="bold">
                    {localize.daily_task}
                </PrimaryCaption>
                <Image
                    source={calendar_ic}
                    style={pageStyles.headerIcon}
                />
            </View>
            <View style={styles.divider} />
            <View style={pageStyles.contain}>
                <PrimaryTitle>
                    {daily_task && daily_task.content}
                </PrimaryTitle>
                {
                    daily_task.task && daily_task.task.map((item) =>
                        <PrimaryTitle key={String(item.id)} size={15}>
                            {item.content}
                        </PrimaryTitle>
                    )
                }
                <View style={{ height: 10 }} />
                <Button
                    title={localize.start}
                    size="small"
                    onPress={() => handleClick(Platform.select({ web: "dashboard/daily-task", android: "daily_task", ios: "daily_task" }))}
                />
            </View>
        </View>
    )
}

export function WCRiddlePaper({ handleClick }) {
    let { daily_riddle } = useSelector(({ main }) => main)
    daily_riddle = daily_riddle || []

    // const [fadeAnim] = useState(new Animated.Value(0))
    // useEffect(() => {
    //     Animated.timing(
    //         fadeAnim,
    //         {
    //             toValue: 1,
    //             easing: Easing.bounce,
    //             duration: 2000,
    //         }
    //     ).start();
    // }, [])
    if (daily_riddle.status === 201) return null;
    return (
        <View style={pageStyles.paper}>
            <View style={pageStyles.header}>
                <PrimaryCaption weight="bold">
                    {localize.riddle_me_this}
                </PrimaryCaption>
                <Image
                    source={riddle_ic}
                    style={pageStyles.riddle_ic}
                />
            </View>

            <View style={styles.divider} />

            <View style={pageStyles.contain}>
                <PrimaryTitle size={15}>
                    {daily_riddle && daily_riddle.question}
                </PrimaryTitle>
                <View style={{ height: 10 }} />
                <Button
                    title={localize.answer}
                    size="small"
                    onPress={() => handleClick(Platform.select({ web: "dashboard/daily-riddle", android: "daily_riddle", ios: "daily_riddle" }))}
                />
            </View>
        </View>
    )
}

export function ProgressPaper({ title, description, buttonTitle, buttonAction }) {
    // const [fadeAnim] = useState(new Animated.Value(0))
    // useEffect(() => {
    //     Animated.timing(
    //         fadeAnim,
    //         {
    //             toValue: 1,
    //             easing: Easing.bounce,
    //             duration: 2000,
    //         }
    //     ).start();
    // }, [])
    return (
        <View style={pageStyles.paper}>
            <View style={pageStyles.header}>
                <SubtitleCapBold>
                    {title}
                </SubtitleCapBold>
            </View>

            <View style={styles.divider} />

            <View style={pageStyles.contain}>
                <BodyTitle>
                    {description}
                </BodyTitle>
                <View style={pageStyles.containButton}>
                    <Button
                        title={buttonTitle}
                        size="small"
                        onPress={buttonAction}
                    />
                </View>
            </View>
        </View>
    )
}

export function WETimeProgressPaper({ handleClick }) {

    const selectedUser = useSelector(({ statistics }) => statistics.selected_user);

    var second = selectedUser.total_online || 0;
    var hours = Math.floor(second / 3600)
    var minutes = Math.floor(second / 60) % 60

    return (
        <View style={pageStyles.paper}>

            <View style={pageStyles.header}>
                <SubtitleCapBold>
                    {localize.Total_Time}
                </SubtitleCapBold>
            </View>

            <View style={styles.divider} />

            <View style={pageStyles.contain}>
                <View style={pageStyles.rowCenter}>
                    <Text style={pageStyles.progressTitle}>
                        {localize.Woogi_English}
                    </Text>
                    <Text style={pageStyles.progressValue}>{hours !== 0 && `${hours}h`} {minutes !== 0 && `${minutes}m`}</Text>
                </View>

                <View style={pageStyles.containButton}>
                    <Button
                        title={localize.VIEW}
                        size="small"
                        onPress={() => {
                            let root = "/statistics/Time";
                            if (global.isNative) {
                                root = "Time";
                            }
                            handleClick(root)
                        }}
                    />
                </View>
            </View>
        </View>
    )
}

export function WEUnitProgressPaper({ handleClick }) {
    const selectedUser = useSelector(({ statistics }) => statistics.selected_user);

    return (
        <View style={pageStyles.paper}>

            <View style={pageStyles.header}>
                <SubtitleCapBold>
                    {localize.Unit_Progress}
                </SubtitleCapBold>
            </View>

            <View style={styles.divider} />

            <View style={pageStyles.contain}>
                <View style={pageStyles.rowCenter}>
                    <Text style={pageStyles.progressTitle}>
                        {localize.Woogi_English}
                    </Text>
                    <Text style={pageStyles.progressValue}>{selectedUser.unit_progress || 0}%</Text>
                </View>

                <View style={{ marginVertical: 5 }}>
                    <Component.Progress progress={selectedUser.unit_progress || 0 + '%'} />
                </View>

                <View style={pageStyles.containButton}>
                    <Button
                        title={localize.VIEW}
                        size="small"
                        onPress={() => {
                            let root = "/statistics/Units";
                            if (global.isNative) {
                                root = "Units";
                            }
                            handleClick(root)
                        }}
                />
                </View>
            </View>
        </View>
    )
}

export function WEActivitiesPaper({ handleClick }) {
    const selectedUser = useSelector(({ statistics }) => statistics.selected_user);

    return (
        <View style={pageStyles.paper}>

            <View style={pageStyles.header}>

                <Component.CaptionBoldDark style={{ fontSize: 14 }} title="Activities" />

            </View>

            <View style={styles.divider} />

            <View style={pageStyles.contain}>
                <View style={pageStyles.rowCenter}>

                    <View style={[pageStyles.rowItem, { borderRightWidth: 1, borderColor: colors.lightGray }]}>
                        <Text style={pageStyles.activityPrimaryText}>
                            {localize.Total_Questions}
                        </Text>
                        <Text style={pageStyles.activitySecondaryText}>
                            {selectedUser.total_question}
                        </Text>
                    </View>

                    <View style={pageStyles.rowItem}>
                        <Text style={{ fontSize: 16, color: colors.midnightBack, fontFamily: global.FONT_REGULAR, fontWeight: '500' }}>
                            {localize.Yesterday}
                        </Text>
                        <Text style={pageStyles.activitySecondaryText}>
                            {selectedUser.yesterday_question}
                        </Text>
                    </View>

                </View>

                <View style={pageStyles.containButton}>
                    <Button
                        title={localize.VIEW}
                        size="small"
                        onPress={() => {
                            let root = "/statistics/Activities";
                            if (global.isNative) {
                                root = "Activities";
                            }
                            handleClick(root)
                        }}
                    />
                </View>
            </View>
        </View>
    )
}


const pageStyles = StyleSheet.create({
    paper: {
        // marginVertical: 20,
        backgroundColor: '#fff',
        borderRadius: 5,
        elevation: 5,
        borderWidth: 0.1,
        borderColor: colors.lightGray,
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.2, shadowRadius: 5,
        shadowColor: 'black',
        marginHorizontal: 15,
        marginTop: 15
    },
    header: {
        flexDirection: "row",
        padding: 12,
        paddingLeft: 15,
        paddingHorizontal: 8,
        justifyContent: 'space-between',
        alignItems: 'center'
    },
    headerIcon: {
        width: 18,
        height: 18,
        resizeMode: "contain"
    },
    contain: {
        flexDirection: 'column',
        paddingHorizontal: 20,
        paddingVertical: 10
    },
    containText: {
        fontFamily: global.FONT_REGULAR,
        fontSize: 15,
        color: colors.midnightBack
    },
    containButton: {
        paddingTop: 10
    },
    rowCenter: {
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between'
    },
    progressTitle: {
        fontSize: 15,
        fontFamily: global.FONT_REGULAR,
        color: colors.indigo,
        fontWeight: '600'
    },
    progressValue: {
        fontSize: 15,
        fontFamily: global.FONT_REGULAR,
        color: colors.midnightBack
    },
    rowItem: {
        width: '50%',
        justifyContent: 'center',
        alignItems: 'center'
    },
    activityPrimaryText: {
        fontSize: 13,
        color: colors.midnightBack,
        fontFamily: global.FONT_REGULAR,
        fontWeight: '500'
    },
    activitySecondaryText: {
        fontSize: 18,
        color: colors.midnightBack,
        fontFamily: global.FONT_REGULAR
    },
    riddle_ic: {
        width: 40,
        height: 40,
        marginTop: -10,
        marginRight: -8,
        resizeMode: "contain"
    }
})